import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface CountdownTimerProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
}
export function CountdownTimer({
  initialHours = 1,
  initialMinutes = 30,
  initialSeconds = 24
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const totalSeconds = initialHours * 3600 + initialMinutes * 60 + initialSeconds;
    let currentSeconds = totalSeconds;
    const timer = setInterval(() => {
      currentSeconds--;
      if (currentSeconds < 0) {
        currentSeconds = totalSeconds; // Reset
      }
      setTimeLeft({
        hours: Math.floor(currentSeconds / 3600),
        minutes: Math.floor(currentSeconds % 3600 / 60),
        seconds: currentSeconds % 60
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [initialHours, initialMinutes, initialSeconds]);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const TimeUnit = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-263">
      <div className="relative flex min-w-[58px] items-center justify-center overflow-hidden rounded-lg border border-navy-700/50 bg-navy-900 p-2 shadow-inner sm:min-w-[70px] sm:p-3 md:min-w-[90px] md:p-4" data-id="element-264">
        <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" data-id="element-265" />
        <AnimatePresence mode="popLayout" data-id="element-266">
          <motion.span key={value} initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: -20,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="font-anton text-2xl tracking-wide text-gold-500 sm:text-3xl md:text-5xl md:tracking-wider" data-id="element-267">
            {formatNumber(value)}
          </motion.span>
        </AnimatePresence>
      </div>
      <span className="mt-1.5 font-oswald text-[11px] uppercase tracking-wide text-gray-400 sm:mt-2 sm:text-sm sm:tracking-widest" data-id="element-268">
        {label}
      </span>
    </div>;
  return <div className="flex items-center justify-center gap-1.5 sm:gap-2 md:gap-4" data-id="element-269">
      <TimeUnit value={timeLeft.hours} label="Hours" data-id="element-270" />
      <span className="pb-5 font-anton text-xl text-navy-700 sm:text-2xl md:pb-6 md:text-4xl" data-id="element-271">
        :
      </span>
      <TimeUnit value={timeLeft.minutes} label="Minutes" data-id="element-272" />
      <span className="pb-5 font-anton text-xl text-navy-700 sm:text-2xl md:pb-6 md:text-4xl" data-id="element-273">
        :
      </span>
      <TimeUnit value={timeLeft.seconds} label="Seconds" data-id="element-274" />
    </div>;
}